import React from "react";

const OrderTag = ({ color, title, children }) => (
  <span
    title={title}
    style={{
      display: "inline-block",
      marginTop: "6px",
      color,
      border: `2px solid ${color}`,
      padding: "3px 6px",
      borderRadius: "8px",
      fontWeight: "bold",
      whiteSpace: "nowrap",
    }}
  >
    {children}
  </span>
);

export default OrderTag;
